(function () {
  'use strict';

  var MEN_HANDLE = 'mens-parfum-discovery-set';
  var WOMEN_HANDLE = 'womens-parfum-discovery-set';

  function currentHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function isDiscovery(handle) {
    return handle === MEN_HANDLE || handle === WOMEN_HANDLE;
  }

  function addStyles() {
    if (document.getElementById('pw-discovery-ux-styles')) return;

    var style = document.createElement('style');
    style.id = 'pw-discovery-ux-styles';
    style.textContent = `
      @media screen and (min-width: 750px) {
        .pw-discovery-stack {
          display: grid !important;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          grid-template-areas:
            "cod credit"
            "trust trust"
            "payment payment";
          gap: 10px 12px;
          align-items: stretch;
        }
        .pw-discovery-stack > .pw-partial-cod {
          grid-area: cod;
          margin: 0 !important;
          height: 100%;
        }
        .pw-discovery-stack > .pw-discovery-credit {
          grid-area: credit;
          margin: 0 !important;
          height: 100%;
        }
        .pw-discovery-stack > .pw-discovery-trust {
          grid-area: trust;
          margin: 0 !important;
        }
        .pw-discovery-stack > .pw-discovery-payment {
          grid-area: payment;
          margin-top: 0 !important;
        }
      }

      .pw-cross-discovery {
        max-width: 1180px;
        margin: 18px auto 0;
      }
      .pw-cross-discovery__card {
        display: grid;
        grid-template-columns: 112px minmax(0, 1fr) auto;
        align-items: center;
        gap: 18px;
        overflow: hidden;
        padding: 12px 14px 12px 12px;
        border: 1px solid rgba(92, 107, 192, .16);
        border-radius: 18px;
        background: linear-gradient(135deg, #fff 0%, #f7f5ff 100%);
        color: #3a3e66;
        text-decoration: none;
        box-shadow: 0 8px 24px rgba(58, 62, 102, .05);
        transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
      }
      .pw-cross-discovery__card:hover {
        transform: translateY(-2px);
        border-color: rgba(140, 158, 238, .34);
        box-shadow: 0 12px 30px rgba(58, 62, 102, .09);
      }
      .pw-cross-discovery__media {
        width: 112px;
        height: 90px;
        overflow: hidden;
        border-radius: 13px;
        background: #faf8f5;
      }
      .pw-cross-discovery__media img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
      .pw-cross-discovery__eyebrow {
        display: block;
        margin: 0 0 4px;
        color: #5c6bc0;
        font-size: 9px;
        line-height: 1.2;
        font-weight: 800;
        letter-spacing: .13em;
      }
      .pw-cross-discovery__copy h3 {
        margin: 0 0 5px;
        color: #3a3e66;
        font-size: 16px;
        line-height: 1.25;
      }
      .pw-cross-discovery__copy p {
        margin: 0;
        color: rgba(58, 62, 102, .66);
        font-size: 11.5px;
        line-height: 1.45;
      }
      .pw-cross-discovery__meta {
        display: inline-block;
        margin-top: 7px;
        color: #3a3e66;
        font-size: 10.5px;
        line-height: 1.2;
        font-weight: 700;
      }
      .pw-cross-discovery__cta {
        white-space: nowrap;
        color: #5c6bc0;
        font-size: 11.5px;
        line-height: 1.2;
        font-weight: 800;
      }

      @media screen and (max-width: 749px) {
        .pw-cross-discovery {
          margin: 14px auto 0;
        }
        .pw-cross-discovery__card {
          grid-template-columns: 82px minmax(0, 1fr);
          gap: 11px;
          padding: 10px;
          border-radius: 14px;
        }
        .pw-cross-discovery__media {
          width: 82px;
          height: 76px;
          border-radius: 11px;
        }
        .pw-cross-discovery__copy h3 {
          font-size: 13px;
        }
        .pw-cross-discovery__copy p {
          font-size: 10px;
        }
        .pw-cross-discovery__meta {
          margin-top: 5px;
          font-size: 9.5px;
        }
        .pw-cross-discovery__cta {
          grid-column: 1 / -1;
          padding: 2px 2px 0;
          font-size: 10.5px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function fixDeliveryCopy() {
    var oldNeedle = 'Cash on Delivery is available on carts of ₹999 or more';
    var paragraphs = document.querySelectorAll('#MainContent p');

    paragraphs.forEach(function (paragraph) {
      if (paragraph.textContent.indexOf(oldNeedle) !== -1) {
        paragraph.innerHTML = 'Prepaid payments are available on all orders. <strong>Partial COD is available on eligible Indian orders.</strong> For this ₹799 Discovery Set, pay <strong>₹199 online</strong> to confirm your order and <strong>₹600 on delivery</strong>. No additional COD fee.';
      }
    });
  }

  function normaliseImage(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function addCrossDiscoveryCard(handle) {
    var grid = document.querySelector('.pw-meet-four__grid');
    if (!grid || document.querySelector('.pw-cross-discovery')) return;

    var isMen = handle === MEN_HANDLE;
    var targetHandle = isMen ? WOMEN_HANDLE : MEN_HANDLE;
    var targetTitle = isMen ? 'Women’s Parfum Discovery Set' : 'Men’s Parfum Discovery Set';
    var targetScents = isMen
      ? 'Bloom · Mist · Imperium · Aura'
      : 'G.O.A.T · Amour · Imperium · Aura';
    var targetCta = isMen ? 'Explore Women’s Set →' : 'Explore Men’s Set →';
    var targetUrl = '/products/' + targetHandle;

    var wrap = document.createElement('div');
    wrap.className = 'pw-cross-discovery';
    wrap.innerHTML =
      '<a class="pw-cross-discovery__card" href="' + targetUrl + '">' +
        '<div class="pw-cross-discovery__media" aria-hidden="true"></div>' +
        '<div class="pw-cross-discovery__copy">' +
          '<span class="pw-cross-discovery__eyebrow">EXPLORE THE OTHER SET</span>' +
          '<h3>' + targetTitle + '</h3>' +
          '<p>' + targetScents + '</p>' +
          '<span class="pw-cross-discovery__meta">4 × 2.5ml · 10ml total · ₹799</span>' +
        '</div>' +
        '<span class="pw-cross-discovery__cta">' + targetCta + '</span>' +
      '</a>';

    grid.insertAdjacentElement('afterend', wrap);

    fetch(targetUrl + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed');
        return response.json();
      })
      .then(function (product) {
        var imageUrl = normaliseImage(product.featured_image || (product.images && product.images[0]));
        if (!imageUrl) return;
        var media = wrap.querySelector('.pw-cross-discovery__media');
        if (!media) return;
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = targetTitle;
        img.src = imageUrl;
        media.appendChild(img);
      })
      .catch(function () {
        /* Keep the navigation card usable even if the image request fails. */
      });
  }

  function init() {
    var handle = currentHandle();
    if (!isDiscovery(handle)) return;

    addStyles();
    fixDeliveryCopy();
    addCrossDiscoveryCard(handle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();